// removed by extract-text-webpack-plugin
module.exports = {"monthly_records":"monthly_records__3yuPF","monthly_selector_wrapper":"monthly_selector_wrapper__3VG--"};


//////////////////
// WEBPACK FOOTER
// ./components/records-monthly/style.scss
// module id = lzjs
// module chunks = 6